import React, { Component } from "react";
import {
  loading,
  NavbarWarehouse,
  Pagination,
  Modal,
  t,
  Select
} from "../../components/CustomComponent.js"; // ปรับ Path ให้ตรงกับโปรเจกต์ของคุณ

export default class TechnicianStock extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter_search: "",
      filter_status: "",
      
      count: 45,
      page: 1,
      page_size: 10,

      active_van: "VAN-001", // เก็บ ID ของรถที่ถูกเลือกเพื่อแสดงข้อมูลตารางด้านล่าง

      // Modal States
      modal_transfer: false,
      modal_adjust: false,
      modal_restock: false,

      // Form States (ใช้ร่วมกันใน Modal)
      form_part: "",
      form_qty: "",
      form_note: "",

      // Mock Data: Summary Stats
      summary: {
        total_vans: 8,
        total_items: 342,
        low_stock_vans: 3,
        total_value: "485K",
      },

      // Mock Data: Van/Technician Cards
      vans: [
        {
          id: "VAN-001", license: "กษ-1234", status: t("van_status_in_use"), statusColor: "success", headerBg: "bg-primary",
          techName: "Somchai Jaidee", techRole: t("role_senior_technician"), initials: "SO", techBg: "bg-success",
          totalItems: 45, okItems: 42, lowItems: 3, lastRestock: `2 ${t("days_ago")}`
        },
        {
          id: "VAN-002", license: "กค-5678", status: t("van_status_need_restock"), statusColor: "warning", headerBg: "bg-warning",
          techName: "Prasit Wongsawan", techRole: t("technician_short"), initials: "PR", techBg: "bg-warning",
          totalItems: 32, okItems: 25, lowItems: 7, lastRestock: t("restock_requested"), isWarning: true
        },
        {
          id: "VAN-003", license: "กง-9012", status: t("van_status_in_use"), statusColor: "success", headerBg: "bg-success",
          techName: "Wichai Srisuk", techRole: t("technician_short"), initials: "WI", techBg: "bg-success",
          totalItems: 58, okItems: 56, lowItems: 2, lastRestock: `1 ${t("days_ago")}`
        },
        {
          id: "VAN-004", license: "กจ-3456", status: t("van_status_parked"), statusColor: "secondary", headerBg: "bg-secondary",
          techName: "Anan Thongdee", techRole: t("role_technician_leave"), initials: "AN", techBg: "bg-secondary",
          totalItems: 38, okItems: 38, lowItems: 0, lastRestock: `${t("maintenance_until")} 15/01`, isInactive: true
        }
      ],

      // Mock Data: Detail Table for Selected Van
      stock_details: [
        { id: "PRT-002456", desc: "Filter Element 10 Micron", quantity: 8, min: 5, max: 15, status: t("ok_status"), statusColor: "success", last_used: "09/01/2025", actionText: t("adjust_short"), actionType: "adjust", actionColor: "primary" },
        { id: "PRT-003789", desc: "Bearing 6205-2RS", quantity: 2, min: 5, max: 20, status: t("low_status"), statusColor: "warning", last_used: "10/01/2025", actionText: t("restock"), actionType: "restock", actionColor: "primary" },
        { id: "PRT-005678", desc: "Contactor 3P 25A", quantity: 4, min: 2, max: 8, status: t("ok_status"), statusColor: "success", last_used: "08/01/2025", actionText: t("adjust_short"), actionType: "adjust", actionColor: "primary" },
        { id: "PRT-006789", desc: "V-Belt A68", quantity: 1, min: 3, max: 10, status: t("low_status"), statusColor: "warning", last_used: "10/01/2025", actionText: t("restock"), actionType: "restock", actionColor: "primary" },
        { id: "PRT-007890", desc: "Fuse 10A", quantity: 25, min: 10, max: 50, status: t("ok_status"), statusColor: "success", last_used: "07/01/2025", actionText: t("adjust_short"), actionType: "adjust", actionColor: "primary" }
      ]
    };
  }

  async componentDidMount() {
    loading(false);
  }

  Get = async (page) => {
    // API logic will go here
  }

  // --- ฟังก์ชันเปิด Modal ---
  openTransferModal = () => {
    this.setState({ modal_transfer: true, form_part: "", form_qty: "", form_note: "" });
  }

  openAdjustModal = (partId = "") => {
    this.setState({ modal_adjust: true, form_part: partId, form_qty: "", form_note: "" });
  }

  openRestockModal = (partId = "") => {
    this.setState({ modal_restock: true, form_part: partId, form_qty: "", form_note: "" });
  }
render() {
    const { 
      summary, vans, active_van, stock_details,
      filter_search, filter_status, count,
      modal_transfer, modal_adjust, modal_restock,
      form_part, form_qty, form_note
    } = this.state;

    const activeVanData = vans.find(v => v.id === active_van);

    return (
      <div className="w-100 min-vh-100" style={{ backgroundColor: "#F4F7FE" }}>
        <NavbarWarehouse />
        <div className="body p-4 mt-3">
          
          {/* Header Section */}
            <div className="mb-4">
              <h3 className="fw-bold mb-1 text-dark">{t("van_inventory")}</h3>
              <div className="text-secondary text-14">{t("manage_van_inventory")}</div>
            </div>

          {/* Top Stats Cards (4 Columns) */}
          <div className="row g-3 mb-4">
            <div className="col-lg-3 col-md-6">
              <div className="card border-0 rounded-4 shadow-sm p-3 h-100 bg-white">
                <div className="d-flex align-items-center">
                  <div className="wpx-40 hpx-40 me-3 rounded-3 bg-primary-light text-primary d-flex align-items-center justify-content-center text-20 icon">
                    {"\uf0d1"}
                  </div>
                  <div>
                    <div className="text-secondary text-12 mb-1 fw-bold">{t("total_vans")}</div>
                    <h3 className="fw-bold text-dark mb-0">{summary.total_vans}</h3>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="card border-0 rounded-4 shadow-sm p-3 h-100 bg-white">
                <div className="d-flex align-items-center">
                  <div className="wpx-40 hpx-40 me-3 rounded-3 bg-success-light text-success d-flex align-items-center justify-content-center text-20 icon">
                    {"\uf494"}
                  </div>
                  <div>
                    <div className="text-secondary text-12 mb-1 fw-bold">{t("total_items_in_vans")}</div>
                    <h3 className="fw-bold text-dark mb-0">{summary.total_items}</h3>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="card border-0 rounded-4 shadow-sm p-3 h-100 bg-white">
                <div className="d-flex align-items-center">
                  <div className="wpx-40 hpx-40 me-3 rounded-3 bg-warning-light text-warning d-flex align-items-center justify-content-center text-20 icon">
                    {"\uf017"}
                  </div>
                  <div>
                    <div className="text-secondary text-12 mb-1 fw-bold">{t("waiting_restock")}</div>
                    <h3 className="fw-bold text-warning mb-0">{summary.low_stock_vans}</h3>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="card border-0 rounded-4 shadow-sm p-3 h-100 bg-white">
                <div className="d-flex align-items-center">
                  <div className="wpx-40 hpx-40 me-3 rounded-3 bg-purple-light text-purple d-flex align-items-center justify-content-center text-20 icon">
                    {"\uf1da"}
                  </div>
                  <div>
                    <div className="text-secondary text-12 mb-1 fw-bold">{t("van_stock_value")}</div>
                    <h3 className="fw-bold text-dark mb-0">{summary.total_value}</h3>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Vans List Cards */}
          <div className="row g-3 mb-4">
            {vans.map((van, idx) => (
              <div className="col-lg-3 col-md-6" key={idx}>
                <div 
                  className={`card border-0 rounded-4 shadow-sm h-100 bg-white pointer transition-hover ${active_van === van.id ? 'border border-primary border-2 shadow' : ''} ${van.isInactive ? 'opacity-75' : ''}`}
                  onClick={() => this.setState({ active_van: van.id })}
                >
                  <div className={`p-3 text-white d-flex justify-content-between align-items-center rounded-top-4 ${van.headerBg}`}>
                    <div>
                      <h6 className="fw-bold mb-0">{van.id}</h6>
                      <div className="text-white text-12">{t("license_label")}: {van.license}</div>
                    </div>
                    <span className={`badge rounded-pill px-2 py-1 text-10 fw-bold ${van.headerBg === 'bg-warning' ? 'bg-white text-warning' : 'bg-white-light text-white'}`}>
                      {van.status}
                    </span>
                  </div>
                  <div className="p-3">
                    <div className="d-flex align-items-center mb-4">
                      <div className={`wpx-35 hpx-35 rounded-circle text-white d-flex align-items-center justify-content-center fw-bold text-12 me-3 ${van.techBg}`}>
                        {van.initials}
                      </div>
                      <div>
                        <div className="fw-bold text-dark text-14 mb-0">{van.techName}</div>
                        <div className="text-secondary text-12">{van.techRole}</div>
                      </div>
                    </div>
                    <div className="row text-center mb-3">
                      <div className="col-4 border-end">
                        <h5 className="fw-bold text-dark mb-0">{van.totalItems}</h5>
                        <div className="text-secondary text-10">{t("items_unit")}</div>
                      </div>
                      <div className="col-4 border-end">
                        <h5 className="fw-bold text-success mb-0">{van.okItems}</h5>
                        <div className="text-secondary text-10">{t("ok_status")}</div>
                      </div>
                      <div className="col-4">
                        <h5 className={`fw-bold mb-0 ${van.lowItems > 0 ? 'text-warning' : 'text-secondary'}`}>{van.lowItems}</h5>
                        <div className="text-secondary text-10">{t("low_status")}</div>
                      </div>
                    </div>
                  </div>
                  <div className="p-3 border-top d-flex justify-content-between align-items-center mt-auto bg-light rounded-bottom-4">
                    <div className={`text-12 fw-bold ${van.isWarning ? 'text-warning' : 'text-secondary'}`}>
                      {van.lastRestock}
                    </div>
                    <div className="d-flex gap-2">
                      <span className="icon text-secondary pointer text-14 hover-primary transition-hover">{"\uf06e"}</span>
                      <span className="icon text-secondary pointer text-14 hover-primary transition-hover">{"\uf0ec"}</span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Details Section for Selected Van */}
          {activeVanData && (
            <div className="card border-0 rounded-4 shadow-sm bg-white overflow-hidden">
              
              {/* Header Action Bar */}
              <div className="p-4 border-bottom d-flex flex-wrap justify-content-between align-items-center gap-3 bg-white">
                <div className="d-flex align-items-center">
                  <div className="wpx-40 hpx-40 rounded-3 bg-primary-light text-primary d-flex align-items-center justify-content-center text-20 icon me-3">
                    {"\uf0d1"}
                  </div>
                  <div>
                    <h5 className="fw-bold text-dark mb-0">{t("van_stock_details")}</h5>
                    <div className="text-secondary text-14">{activeVanData.techName} - {activeVanData.totalItems} {t("items_unit")}</div>
                  </div>
                </div>
                
                <div className="d-flex gap-2 flex-wrap">
                  <button className="btn btn-white border px-3 py-2 fw-bold rounded-3 shadow-sm text-dark d-flex align-items-center">
                    <span className="icon me-2">{"\uf02f"}</span> {t("print_list")}
                  </button>
                  <button 
                    className="btn btn-purple px-3 py-2 fw-bold rounded-3 shadow-sm text-white d-flex align-items-center" 
                    style={{ backgroundColor: '#8b5cf6', borderColor: '#8b5cf6' }}
                    onClick={this.openTransferModal}
                  >
                    <span className="icon me-2">{"\uf0ec"}</span> {t("transfer_stock")}
                  </button>
                  <button 
                    className="btn btn-primary px-3 py-2 fw-bold rounded-3 shadow-sm d-flex align-items-center" 
                    onClick={() => this.openRestockModal("")}
                  >
                    <span className="me-2 text-16">+</span> {t("restock")}
                  </button>
                </div>
              </div>

              {/* Filter & Search Bar */}
              <div className="p-3 border-bottom bg-white d-flex flex-wrap justify-content-between align-items-center gap-3">
                <div className="position-relative flex-grow-1" style={{ maxWidth: "300px" }}>
                  <span className="icon position-absolute top-50 start-0 translate-middle-y ms-3 text-secondary text-12">
                    {"\uf002"}
                  </span>
                  <input
                    type="text"
                    className="form-control ps-5 wpx-300"
                    placeholder={t("search_placeholder")}
                    value={filter_search}
                    onChange={(e) => this.setState({ filter_search: e.target.value })}
                  />
                </div>
                <Select
                  className="form-control wpx-150 shadow-none bg-white"
                  options={[
                    { value: "ok", label: t("ok_status") },
                    { value: "low", label: t("low_status") },
                  ]}
                  value={filter_status}
                  onChange={(e) => this.setState({ filter_status: e })}
                  placeholder={t("all_statuses")}
                  defaultLabel={t("all_statuses")}
                />
              </div>

              {/* Table */}
              <div className="table-responsive">
                <table className="table table-hover align-middle mb-0" style={{ minWidth: "900px" }}>
                  <thead>
                    <tr className="text-dark fw-bold text-12 border-bottom border-light bg-light">
                      <th className="py-3 px-4 border-0 wpx-150">{t("part_code")}</th>
                      <th className="py-3 border-0 wpx-250">{t("description")}</th>
                      <th className="py-3 border-0 text-center wpx-120">{t("qty_in_van")}</th>
                      <th className="py-3 border-0 text-center wpx-100">{t("min_qty")}</th>
                      <th className="py-3 border-0 text-center wpx-100">{t("max_qty")}</th>
                      <th className="py-3 border-0 text-center wpx-100">{t("status")}</th>
                      <th className="py-3 border-0 text-center wpx-150">{t("last_used")}</th>
                      <th className="py-3 border-0 text-center wpx-100">{t("manage")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {stock_details.map((item, idx) => (
                      <tr key={idx} className={`border-bottom border-light ${item.statusColor === 'warning' ? 'bg-warning-light' : 'bg-white'}`}>
                        <td className="py-3 px-4">
                          <span className="fw-bold text-primary text-14 pointer hover-underline">{item.id}</span>
                        </td>
                        <td>
                          <div className="text-dark text-14">{item.desc}</div>
                        </td>
                        <td className="text-center">
                          <span className={`fw-bold text-14 ${item.statusColor === 'warning' ? 'text-warning' : 'text-dark'}`}>{item.quantity}</span>
                        </td>
                        <td className="text-center text-secondary text-14">{item.min}</td>
                        <td className="text-center text-secondary text-14">{item.max}</td>
                        <td className="text-center">
                          <span className={`badge bg-${item.statusColor === 'warning' ? 'warning' : 'success-light'} text-${item.statusColor} rounded-pill px-3 py-1 fw-bold text-10 ${item.statusColor === 'warning' ? 'bg-opacity-25' : ''}`}>
                            {item.status}
                          </span>
                        </td>
                        <td className="text-center text-secondary text-14">{item.last_used}</td>
                        <td className="text-center">
                          <a 
                            href="#" 
                            className={`text-${item.actionColor} text-decoration-none fw-bold text-14 pointer`}
                            onClick={(e) => {
                              e.preventDefault();
                              if(item.actionType === 'adjust') this.openAdjustModal(item.id);
                              else this.openRestockModal(item.id);
                            }}
                          >
                            {item.actionText}
                          </a>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>

        {/* MODAL 1: โอนสต็อก (Transfer Stock) */}
        <Modal
          size="md"
          show={modal_transfer}
          onHide={() => this.setState({ modal_transfer: false })}
          centered
          contentClassName="border-0 rounded-4 overflow-hidden shadow-lg"
        >
          <Modal.Header className="bg-white border-bottom-0 pb-0" closeButton>
            <h4 className="fw-bold mb-0 text-dark">{t("transfer_stock")}</h4>
          </Modal.Header>
          <Modal.Body className="p-4 bg-white">
            <div className="d-flex flex-column gap-3">
              <div>
                <label className="form-label text-14 text-dark fw-bold mb-2">{t("from_location")}</label>
                <Select
                  className="form-control py-2 rounded-3 text-dark"
                  options={[
                    { value: t("main_warehouse"), label: t("main_warehouse") },
                    { value: "VAN-002", label: "VAN-002" },
                    { value: "VAN-003", label: "VAN-003" },
                  ]}
                  value={t("main_warehouse")}
                  onChange={() => {}}
                  placeholder={t("from_location")}
                  default={false}
                />
              </div>
              <div>
                <label className="form-label text-14 text-dark fw-bold mb-2">{t("to_location")}</label>
                <Select
                  className="form-control py-2 rounded-3 text-dark"
                  options={active_van ? [{ value: active_van, label: active_van }] : []}
                  value={active_van}
                  onChange={() => {}}
                  placeholder={t("to_location")}
                  disabled
                  default={false}
                />
              </div>
              <div>
                <label className="form-label text-14 text-dark fw-bold mb-2">{t("part_code")}</label>
                <Select
                  className="form-control py-2 rounded-3 text-dark"
                  options={stock_details.map((p) => ({ value: p.id, label: `${p.id} - ${p.desc}` }))}
                  value={form_part}
                  onChange={(e) => this.setState({ form_part: e })}
                  placeholder={t("select_part")}
                  defaultLabel={t("select_part")}
                />
              </div>
              <div>
                <label className="form-label text-14 text-dark fw-bold mb-2">{t("quantity")}</label>
                <input 
                  type="number" 
                  className="form-control py-2 rounded-3" 
                  placeholder={t("example_5")}
                  value={form_qty}
                  onChange={(e) => this.setState({ form_qty: e.target.value })}
                />
              </div>
              <div>
                <label className="form-label text-14 text-dark fw-bold mb-2">{t("note")}</label>
                <textarea 
                  className="form-control py-2 rounded-3" 
                  rows="2" 
                  placeholder={t("optional_notes")}
                  value={form_note}
                  onChange={(e) => this.setState({ form_note: e.target.value })}
                ></textarea>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="bg-white border-top-0 pt-0 px-4 pb-4 d-flex justify-content-end gap-2">
            <button 
              className="btn btn-white border px-4 py-2 text-dark rounded-3 fw-bold" 
              onClick={() => this.setState({ modal_transfer: false })}
            >
              {t("cancel")}
            </button>
            <button className="btn btn-primary px-4 py-2 rounded-3 fw-bold shadow-sm">
              {t("confirm_transfer")}
            </button>
          </Modal.Footer>
        </Modal>

        {/* MODAL 2: ปรับปรุงสต็อก (Adjust Stock) */}
        <Modal
          size="md"
          show={modal_adjust}
          onHide={() => this.setState({ modal_adjust: false })}
          centered
          contentClassName="border-0 rounded-4 overflow-hidden shadow-lg"
        >
          <Modal.Header className="bg-white border-bottom-0 pb-0" closeButton>
            <h4 className="fw-bold mb-0 text-dark">{t("adjust_stock")}</h4>
          </Modal.Header>
          <Modal.Body className="p-4 bg-white">
            <div className="d-flex flex-column gap-3">
              <div>
                <label className="form-label text-14 text-dark fw-bold mb-2">{t("van_vehicle")}</label>
                <input type="text" className="form-control py-2 rounded-3 text-dark bg-light" value={active_van} readOnly disabled />
              </div>
              <div>
                <label className="form-label text-14 text-dark fw-bold mb-2">{t("part_code")}</label>
                <Select
                  className="form-control py-2 rounded-3 text-dark"
                  options={stock_details.map((p) => ({ value: p.id, label: `${p.id} - ${p.desc}` }))}
                  value={form_part}
                  onChange={(e) => this.setState({ form_part: e })}
                  placeholder={t("select_part")}
                  defaultLabel={t("select_part")}
                />
              </div>
              <div className="row g-2">
                <div className="col-4">
                  <label className="form-label text-14 text-dark fw-bold mb-2">{t("type")}</label>
                  <Select
                    className="form-control py-2 rounded-3 text-dark"
                    options={[
                      { value: "add", label: t("add_type") },
                      { value: "reduce", label: t("reduce_type") },
                    ]}
                    value="add"
                    onChange={() => {}}
                    placeholder={t("type")}
                    default={false}
                  />
                </div>
                <div className="col-8">
                  <label className="form-label text-14 text-dark fw-bold mb-2">{t("quantity")}</label>
                  <input 
                    type="number" 
                    className="form-control py-2 rounded-3" 
                    value={form_qty}
                    onChange={(e) => this.setState({ form_qty: e.target.value })}
                  />
                </div>
              </div>
              <div>
                <label className="form-label text-14 text-dark fw-bold mb-2">{t("adjust_reason")}</label>
                <textarea 
                  className="form-control py-2 rounded-3" 
                  rows="2" 
                  placeholder={t("adjust_reason_placeholder")}
                  value={form_note}
                  onChange={(e) => this.setState({ form_note: e.target.value })}
                ></textarea>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="bg-white border-top-0 pt-0 px-4 pb-4 d-flex justify-content-end gap-2">
            <button 
              className="btn btn-white border px-4 py-2 text-dark rounded-3 fw-bold" 
              onClick={() => this.setState({ modal_adjust: false })}
            >
              {t("cancel")}
            </button>
            <button className="btn btn-primary px-4 py-2 rounded-3 fw-bold shadow-sm">
              {t("save")}
            </button>
          </Modal.Footer>
        </Modal>

        {/* MODAL 3: เติมสต็อก (Restock) */}
        <Modal
          size="md"
          show={modal_restock}
          onHide={() => this.setState({ modal_restock: false })}
          centered
          contentClassName="border-0 rounded-4 overflow-hidden shadow-lg"
        >
          <Modal.Header className="bg-white border-bottom-0 pb-0" closeButton>
            <h4 className="fw-bold mb-0 text-dark">{t("restock_van")}</h4>
          </Modal.Header>
          <Modal.Body className="p-4 bg-white">
            <div className="d-flex flex-column gap-3">
              <div>
                <label className="form-label text-14 text-dark fw-bold mb-2">{t("withdraw_for_van")}</label>
                <input type="text" className="form-control py-2 rounded-3 text-dark bg-light" value={active_van} readOnly disabled />
              </div>
              <div>
                <label className="form-label text-14 text-dark fw-bold mb-2">{t("part_code")}</label>
                <Select
                  className="form-control py-2 rounded-3 text-dark"
                  options={stock_details.map((p) => ({ value: p.id, label: `${p.id} - ${p.desc}` }))}
                  value={form_part}
                  onChange={(e) => this.setState({ form_part: e })}
                  placeholder={t("select_part")}
                  defaultLabel={t("select_part")}
                />
              </div>
              <div>
                <label className="form-label text-14 text-dark fw-bold mb-2">{t("restock_qty")}</label>
                <input 
                  type="number" 
                  className="form-control py-2 rounded-3" 
                  placeholder={t("specify_qty")}
                  value={form_qty}
                  onChange={(e) => this.setState({ form_qty: e.target.value })}
                />
              </div>
              <div>
                <label className="form-label text-14 text-dark fw-bold mb-2">{t("withdraw_note")}</label>
                <textarea 
                  className="form-control py-2 rounded-3" 
                  rows="2" 
                  placeholder={t("optional_notes")}
                  value={form_note}
                  onChange={(e) => this.setState({ form_note: e.target.value })}
                ></textarea>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="bg-white border-top-0 pt-0 px-4 pb-4 d-flex justify-content-end gap-2">
            <button 
              className="btn btn-white border px-4 py-2 text-dark rounded-3 fw-bold" 
              onClick={() => this.setState({ modal_restock: false })}
            >
              {t("cancel")}
            </button>
            <button className="btn btn-primary px-4 py-2 rounded-3 fw-bold shadow-sm">
              {t("create_withdraw_slip")}
            </button>
          </Modal.Footer>
        </Modal>

      </div>
    );
  }
}